import React from 'react';

import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';

import Checkbox from '~/components/checkbox';
import Grid from '~/components/grid';
import { IProposal, IResponseProposalConvenio } from '~/models/proposal';
import { transformInNormalDate } from '~/utils/date';
import { cepMask, cpfMask, currencyMask, phoneMask } from '~/utils/masks';

interface IComponents {
  data: IProposal;
  origem: string;
  dataConvenio?: IResponseProposalConvenio;
}

const ProposalResultSPC: React.FC<IComponents> = ({
  data,
  origem,
  dataConvenio,
}) => {
  const retCPF = cpfMask(
    data.spc?.cpf || dataConvenio?.bureau?.dadosCadastrais?.cpf,
  );
  const retCEP = cepMask(
    data.spc?.endereco?.cep ||
      dataConvenio?.bureau?.dadosCadastrais?.enderecoModel?.cep,
  );
  const dataNascimento =
    data.spc?.dataNascimento ||
    dataConvenio?.bureau?.dadosCadastrais?.dataNascimento
      ? transformInNormalDate(
          data.spc?.dataNascimento.substring(0, 10) ||
            dataConvenio?.bureau?.dadosCadastrais?.dataNascimento.substring(
              0,
              10,
            ),
        )
      : { masked: '', unmasked: '' };
  const retRenda = currencyMask(data.spc?.rendaPresumida);
  const bulletCollor = 'white';
  return (
    <ContainerFlex gap="8" marginLeft={16} marginRight={26}>
      <Input
        label="CPF"
        value={retCPF?.masked}
        readOnly
        bulletColor={bulletCollor}
      />
      <Input
        label="Nome completo"
        value={data.spc?.nome || dataConvenio?.bureau?.dadosCadastrais?.nome}
        readOnly
        bulletColor={bulletCollor}
      />
      <Input
        label="Telefone"
        value={
          phoneMask(data.spc?.celular).masked ||
          phoneMask(dataConvenio?.bureau?.dadosCadastrais?.telefone).masked
        }
        readOnly
        bulletColor={bulletCollor}
      />
      <Input
        label="Telefone 2"
        value={phoneMask(data.spc?.celular2).masked}
        readOnly
        bulletColor={bulletCollor}
      />
      <Input
        label="E-mail"
        value={data.spc?.email || dataConvenio?.bureau?.dadosCadastrais?.email}
        readOnly
        bulletColor={bulletCollor}
      />
      <Input
        label="Data de nascimento"
        value={
          dataNascimento.masked ||
          dataConvenio?.bureau?.dadosCadastrais?.dataNascimento
        }
        readOnly
        bulletColor={bulletCollor}
      />
      <Input
        label="CEP"
        name="cep"
        mask={MaskTypes.CEP}
        maxLength={9}
        placeholder="00000-000"
        value={retCEP?.masked}
        readOnly
        bulletColor={bulletCollor}
      />
      <Input
        label="Endereço"
        value={
          data.spc?.endereco?.logradouro ||
          dataConvenio?.bureau?.dadosCadastrais?.enderecoModel?.logradouro
        }
        readOnly
        bulletColor={bulletCollor}
      />
      <div>
        <Grid xs={1} sm={2} md={3} gap={10}>
          <Input
            label="Bairro"
            value={
              data.spc?.endereco?.bairro ||
              dataConvenio?.bureau?.dadosCadastrais?.enderecoModel?.bairro
            }
            readOnly
            bulletColor={bulletCollor}
          />
          <Input
            label="Número"
            value={
              data.spc?.endereco?.numero ||
              dataConvenio?.bureau?.dadosCadastrais?.enderecoModel?.numero
            }
            readOnly
            bulletColor={bulletCollor}
          />
          <Input
            label="Complemento"
            value={
              data.spc?.endereco?.complemento ||
              dataConvenio?.bureau?.dadosCadastrais?.enderecoModel?.complemento
            }
            readOnly
            bulletColor={bulletCollor}
          />
        </Grid>

        <Grid xs={1} lg={2} gap={10}>
          <Input
            label="Cidade"
            value={
              data.spc?.endereco?.cidade ||
              dataConvenio?.bureau?.dadosCadastrais?.enderecoModel?.cidade
            }
            readOnly
            bulletColor={bulletCollor}
          />
          <Input
            label="UF"
            value={
              data.spc?.endereco?.uf ||
              dataConvenio?.bureau?.dadosCadastrais?.enderecoModel?.uf
            }
            readOnly
            bulletColor={bulletCollor}
          />
        </Grid>
      </div>
      {origem !== 'CONVENIO' && (
        <>
          <Input
            label="Renda estimada"
            value={retRenda}
            readOnly
            bulletColor={bulletCollor}
          />
          <Checkbox
            message="Possui emprego formal"
            value={data.spc?.empregoFormal}
            readonly
            bulletColor={bulletCollor}
          />
          <br />
          <Input
            label="Informação profissional"
            value={data.spc?.profissao}
            readOnly
            bulletColor={bulletCollor}
          />
          <br />
          <ContainerFlex />
          <ContainerFlex marginBottom={20} marginTop={10} />
          <ContainerFlex />
          {/*
          <br />
          <br />
          <br /> */}
        </>
      )}
    </ContainerFlex>
  );
};

export default ProposalResultSPC;
